
var  liveData = [
        [
            {
                title: '主论坛',
                links:[
                    {
                        name:'微吼直播',
                        link:' http://e.vhall.com/701353725'
                    },
                    {
                        name:'三千氪',
                        link:'https://3qk.easyvaas.com/show/play/index?vid=BzA0MS5bRD6lh2p5'
                    }
                ]
            },
            {
                title: '品类爆发与品质崛起',
                links:[
                    {
                        name:'微吼直播',
                        link:'http://e.vhall.com/733945677'
                    }
                ]
            },
            {
                title: '人群迭代与场景创新',
                links:[
                    {
                        name:'三千氪',
                        link:'https://3qk.easyvaas.com/show/play/index?vid=PeYKdIOR0Xylumr0'
                    }                        ]
            },
            {
                title: '现场精彩图片',
                links:[
                    {
                        name:'谱时',
                        link:'http://t.cn/RCvhdFr'
                    }                        ]
            }
        ],
        [
            {
                title: '主论坛',
                links:[
                    {
                        name:'微吼直播',
                        link:'http://e.vhall.com/580230662'
                    },
                    {
                        name:'视友直播',
                        link:'http://blive.cuctv.com/nl/1f5lDRu8fMc.html'
                    }
                ]
            },
            {
                title: '保险行业论坛',
                links:[
                    {
                        name:'微吼直播',
                        link:'http://e.vhall.com/378818341'
                    },
                    {
                        name:'视友直播',
                        link:'http://blive.cuctv.com/nl/1f5lDRu8fMc.html'
                    }
                ]
            },
            {
                title: '金融行业企业服务',
                links:[
                    {
                        name:'微吼直播',
                        link:'http://e.vhall.com/368405011'
                    }                        
                ]
            },
            {
                title: '人工智能论坛',
                links:[
                    {
                        name:'微吼直播',
                        link:'http://e.vhall.com/580230662'
                    }                        
                ]
            }
        ]
    ]

export default liveData



// WEBPACK FOOTER //
// ./src/assets/js/livedata.js